import { render } from "./BaseSwitch.vue?vue&type=template&id=20de6915"
import script from "./BaseSwitch.vue?vue&type=script&lang=js"
export * from "./BaseSwitch.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\01_product\\05_konoike\\01_src\\2024_4th\\stg\\ConcreteOperationManagement\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/BaseSwitch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20de6915"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20de6915', __exports__)) {
    console.log('reload')
    api.reload('20de6915', __exports__)
  }
  
  module.hot.accept("./BaseSwitch.vue?vue&type=template&id=20de6915", () => {
    console.log('re-render')
    api.rerender('20de6915', render)
  })

}


export default __exports__